export const CATEGORIES = [
  {
    id: 1,
    name: "MAKEUP",
    __typename: "ProductCategory",
  },
  {
    id: 2,
    name: "HATS",
    __typename: "ProductCategory",
  },
  {
    id: 3,
    name: "GLASSES",
    __typename: "ProductCategory",
  },
]
